// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header_header__VEMbK {
  background: var(--bg-surface);
  padding: 0 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 1px 0 var(--border);
  position: sticky;
  top: 0;
  z-index: 999;
  border-bottom: 1px solid var(--border);
}

.Header_headerLeft__QfXwP  { display: flex; align-items: center; }
.Header_headerRight__8bVIx { display: flex; align-items: center; }

.Header_header__VEMbK .Header_trigger__uYLPh {
  font-size: 20px;
  padding: 0 14px;
  height: 40px;
  cursor: pointer;
  transition: all 0.2s ease;
  border-radius: var(--radius-sm);
  color: var(--text-secondary);
  display: flex;
  align-items: center;
}

.Header_header__VEMbK .Header_trigger__uYLPh .trigger-icon,
.Header_header__VEMbK .Header_trigger__uYLPh svg {
  width: 20px;
  height: 20px;
  color: inherit;
  stroke: currentColor;
}

.Header_header__VEMbK .Header_trigger__uYLPh:hover .trigger-icon,
.Header_header__VEMbK .Header_trigger__uYLPh:hover svg {
  color: var(--accent-hover);
  stroke: currentColor;
}

.Header_userButton__KlrNG {
  display: flex;
  align-items: center;
  height: 40px;
  padding: 6px 12px 6px 6px;
  border-radius: 999px;
  transition: all 0.2s ease;
  border: 1px solid transparent;
  background: transparent;
}

.Header_userButton__KlrNG:hover {
  background: var(--bg-hover) !important;
  border-color: var(--border-strong);
}

.Header_userButton__KlrNG .ant-avatar {
  background: var(--accent-grad);
  border: none;
  box-shadow: 0 2px 8px var(--accent-glow);
}

.Header_userNameText__JBPs0 {
  color: var(--text-primary);
  font-weight: 500;
  margin-left: 8px;
  font-size: 14px;
}

.Header_userInfo__D5taA {
  padding: 8px 4px;
  min-width: 200px;
}

.Header_userName__CHy3i {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 6px;
  word-break: break-all;
}

.Header_userRole__h13hC {
  font-size: 12px;
  color: var(--accent-hover);
  padding: 2px 10px;
  background: var(--accent-glow);
  border-radius: 6px;
  display: inline-block;
}

@media (max-width: 768px) {
  .Header_header__VEMbK { padding: 0 16px; }
  .Header_userNameText__JBPs0 { display: none; }
  .Header_userButton__KlrNG { padding: 6px; }
}

@media (max-width: 576px) {
  .Header_header__VEMbK { padding: 0 12px; }
  .Header_header__VEMbK .Header_trigger__uYLPh { padding: 0 10px; font-size: 18px; }
}`, "",{"version":3,"sources":["webpack://./src/components/common/Layout/Header.module.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iCAAiC;EACjC,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,sCAAsC;AACxC;;AAEA,6BAAe,aAAa,EAAE,mBAAmB,EAAE;AACnD,6BAAe,aAAa,EAAE,mBAAmB,EAAE;;AAEnD;EACE,eAAe;EACf,eAAe;EACf,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oBAAoB;AACtB;;AAEA;;EAEE,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,oBAAoB;EACpB,yBAAyB;EACzB,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,iBAAiB;EACjB,8BAA8B;EAC9B,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,wBAAU,eAAe,EAAE;EAC3B,8BAAgB,aAAa,EAAE;EAC/B,4BAAc,YAAY,EAAE;AAC9B;;AAEA;EACE,wBAAU,eAAe,EAAE;EAC3B,+CAAmB,eAAe,EAAE,eAAe,EAAE;AACvD","sourcesContent":[".header {\n  background: var(--bg-surface);\n  padding: 0 24px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  box-shadow: 0 1px 0 var(--border);\n  position: sticky;\n  top: 0;\n  z-index: 999;\n  border-bottom: 1px solid var(--border);\n}\n\n.headerLeft  { display: flex; align-items: center; }\n.headerRight { display: flex; align-items: center; }\n\n.header .trigger {\n  font-size: 20px;\n  padding: 0 14px;\n  height: 40px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border-radius: var(--radius-sm);\n  color: var(--text-secondary);\n  display: flex;\n  align-items: center;\n}\n\n.header .trigger :global(.trigger-icon),\n.header .trigger svg {\n  width: 20px;\n  height: 20px;\n  color: inherit;\n  stroke: currentColor;\n}\n\n.header .trigger:hover :global(.trigger-icon),\n.header .trigger:hover svg {\n  color: var(--accent-hover);\n  stroke: currentColor;\n}\n\n.userButton {\n  display: flex;\n  align-items: center;\n  height: 40px;\n  padding: 6px 12px 6px 6px;\n  border-radius: 999px;\n  transition: all 0.2s ease;\n  border: 1px solid transparent;\n  background: transparent;\n}\n\n.userButton:hover {\n  background: var(--bg-hover) !important;\n  border-color: var(--border-strong);\n}\n\n.userButton :global(.ant-avatar) {\n  background: var(--accent-grad);\n  border: none;\n  box-shadow: 0 2px 8px var(--accent-glow);\n}\n\n.userNameText {\n  color: var(--text-primary);\n  font-weight: 500;\n  margin-left: 8px;\n  font-size: 14px;\n}\n\n.userInfo {\n  padding: 8px 4px;\n  min-width: 200px;\n}\n\n.userName {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin-bottom: 6px;\n  word-break: break-all;\n}\n\n.userRole {\n  font-size: 12px;\n  color: var(--accent-hover);\n  padding: 2px 10px;\n  background: var(--accent-glow);\n  border-radius: 6px;\n  display: inline-block;\n}\n\n@media (max-width: 768px) {\n  .header { padding: 0 16px; }\n  .userNameText { display: none; }\n  .userButton { padding: 6px; }\n}\n\n@media (max-width: 576px) {\n  .header { padding: 0 12px; }\n  .header .trigger { padding: 0 10px; font-size: 18px; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `Header_header__VEMbK`,
	"headerLeft": `Header_headerLeft__QfXwP`,
	"headerRight": `Header_headerRight__8bVIx`,
	"trigger": `Header_trigger__uYLPh`,
	"userButton": `Header_userButton__KlrNG`,
	"userNameText": `Header_userNameText__JBPs0`,
	"userInfo": `Header_userInfo__D5taA`,
	"userName": `Header_userName__CHy3i`,
	"userRole": `Header_userRole__h13hC`
};
export default ___CSS_LOADER_EXPORT___;
